import { AppService } from './app.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin'
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class BlogResolver implements Resolve<any> {
    constructor(private appService: AppService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        let language = route.params['language'];
        if (!environment.allowedLanguages[language]) {
            this.router.navigate(['/not-found']);
            return null;
        }        
        return Observable.forkJoin(
            this.appService.getArticles(language),
        ).map(results => {
            if (results[0]) {
                return results[0].json();             
            }
            return null;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/blog-resolver.service.ts